const AccommodationSearchView = () => import(/* webpackChunkName: "as" */'@/views/AccommodationSearchView');
const AccommodationSingleView = () => import(/* webpackChunkName: "ass" */'@/views/AccommodationSingleView');
import makeSingleMapSightRoute from '@/router/utils/createSingleMapSightRoute';

const accommodationSightMapRouter = [
  makeSingleMapSightRoute({
    sightMapType: 'accommodation',
    category: 'accommodation',
    path: 'accommodation/search',
    route: {
      path: '',
      name: `accommodation-search`,
      component: AccommodationSearchView
    }
  }),
  makeSingleMapSightRoute({
    sightMapType: 'accommodation',
    category: 'accommodation',
    path: 'accommodation/:entity',
    route: {
      path: '',
      name: `accommodation-single`,
      component: AccommodationSingleView
    },
  }),
]

export default accommodationSightMapRouter;